// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"135":"3bd67af2","447":"ec8ca01a"}[chunkId] + ".css";
};